module.exports = __webpack_public_path__ + "img/12-2-fr.1b5dcd0e.svg";